export default __webpack_public_path__ + "static/media/bcg-4.69a1ee9c.jpeg";